module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADqADAAQAAAABAAAACgAAAABIcJ86AAAAzklEQVQoFZWQzQnCQBCF36xCwIvniC14tACxipyCV0EtID2IxB60CkkBHm1AUPGaqwdd563mTwnRgd2dnfnevGXFX9mNBQL8EQJsjdfFVJPTrzqy1JjjRFIjCCFQ44ZQhqzTEL0sJNHCskEGMmTJmQzuAJG6HrL716k9x7wb+uQi+ms7uD+wtxZeUQVEcGsZDM8zyQfnjgTZUFFUFjFnrSxireL4gqz4MXb6VSPelUiuc4xFpPJ5FUfHKWDaCHViyuXyD5EbWLf1Yhtw1fWf6Q07PjUpP+wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down.png
// module id = rix4
// module chunks = 29